export type Type = {
	id: string;
	name: string;
	parent: string;
	children: Type[];
};

export function treeContainsSearchTerm(obj: Type, searchTerm: string): boolean {
	if (obj.name.toLowerCase().includes(searchTerm.toLowerCase())) return true;
	for (const i of obj.children) {
		if (treeContainsSearchTerm(i, searchTerm)) return true;
	}
	return false;
}

export function subTreeContainsSearchTerm(obj: Type, searchTerm: string): boolean {
	for (const i of obj.children) {
		if (treeContainsSearchTerm(i, searchTerm)) return true;
	}
	return false;
}

export function isOpened(obj: Type, searchTerm: string, opened: string[]): boolean {
	if (searchTerm && treeContainsSearchTerm(obj, searchTerm)) return true;
	if (opened.includes(obj.id)) return true;
	return false;
}

export function isUnClosebale(obj: Type, searchTerm: string): boolean {
	if (searchTerm && treeContainsSearchTerm(obj, searchTerm)) return true;
	return false;
}
